export const SET_VOLUME = 'SET_VOLUME';
export const SET_PLAYBACK_RATE = 'SET_PLAYBACK_RATE';
export const SET_MINIMIZED = 'SET_MINIMIZED';

export const playerReducer = (state, action) => {
  switch (action.type) {
    case SET_VOLUME:
      return { ...state, volume: parseFloat(action.payload) };
    case SET_PLAYBACK_RATE:
      return { ...state, playbackRate: parseFloat(action.payload) };
    case SET_MINIMIZED:
      return { ...state, minimized: action.payload };
    default:
      break;
  }
};
